import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { PushNotificationProvider } from './contexts/PushNotificationContext';
import { initializeCapacitor } from './utils/capacitor';
import OfflineIndicator from './components/OfflineIndicator';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerified from './pages/EmailVerified';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import NewOrder from './pages/NewOrder';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  useEffect(() => {
    initializeCapacitor();
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <PushNotificationProvider>
          <WebSocketProvider>
            <BrowserRouter>
              <OfflineIndicator />
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/email-verified" element={<EmailVerified />} />
                
                {/* Protected Routes */}
                <Route path="/dashboard" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                <Route path="/orders/:outletId" element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                } />
                <Route path="/orders/:outletId/new" element={
                  <ProtectedRoute>
                    <NewOrder />
                  </ProtectedRoute>
                } />
                <Route path="/orders/:outletId/:orderId" element={
                  <ProtectedRoute>
                    <OrderDetail />
                  </ProtectedRoute>
                } />
                
                {/* Catch all */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
          </WebSocketProvider>
        </PushNotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
